import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DomainRecord as SchemaDomainRecord } from '../schemas/DomainRecord';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Устанавливает (создаёт или обновляет) запись домена
 * @tags Domains
 * @summary Создание или обновление записи домена
 */
export const SetDomainRecordContentType = 'application/json' as const;
export type SetDomainRecordRequest = SchemaDomainRecord;
export type SetDomainRecordResponses = LinkCommonErrorResponses & {
    /**
     * @description Запись установлена
     */
    '200': {};
};
export type SetDomainRecordResponseSuccess = undefined;
export type SetDomainRecordSearchParams = undefined;
export type SetDomainRecordPathParameters = undefined;
export const SetDomainRecordUrl = '/domain/records' as const;
export const SetDomainRecordMethod = 'POST' as const;
export const getSetDomainRecordUrl = (_params?: SetDomainRecordPathParameters) => SetDomainRecordUrl;
